<app-modal-header (closeModal)="close()"> </app-modal-header>
<app-modal-body>
  <h1 class="fs-5 text-truncate pe-2">{{ productDetail?.title }}</h1>
  <form [formGroup]="form">
    <div class="row gap-3">
      <div class="col-12">
        <p class="form-label fw-medium">
          <i class="ri-arrow-down-s-line fs-5"></i>
          {{ 'PURPOSE' | translate }}
        </p>
        <select name="purpose" class="form-select" formControlName="purpose">
          <option value="" selected disabled>{{ 'SOURCING_PURPOSE' | translate }}</option>
          @for (item of purpose; track $index) {
            <option [value]="item.value">{{ item.label | translate }}</option>
          }
        </select>
        @if (purposeControl.dirty && purposeControl.errors) {
          <p class="text-danger mt-2 fs-13px">{{ 'PLEASE_SELECT_A_PURPOSE' | translate }}</p>
        }
      </div>
      <div class="col-12">
        <p class="form-label fw-medium">
          <i class="ri-arrow-down-s-line fs-5"></i>
          {{ 'QUANTITY' | translate }}
        </p>

        <div class="row">
          <div class="col-4">
            <input type="number" name="unitValue" class="form-control" formControlName="unitValue" min="1" />
            @if (unitValueControl.dirty && unitValueControl.errors) {
              <p class="text-danger mt-2 fs-13px">{{ 'MINIMUM_VALUE_IS_1' | translate }}</p>
            }
          </div>
          <div class="col-8">
            <select name="quantityType" class="form-select" formControlName="quantityType">
              @for (item of quantityType; track $index) {
                <option [value]="item.value">{{ item.label | translate }}</option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="col-12">
        <p class="form-label fw-medium">
          <i class="ri-arrow-down-s-line fs-5"></i>
          {{ 'ADDITIONAL_SOURCING_REQUIREMENTS' | translate }} ({{ additionalInformationControl.value?.length }}/500)
        </p>
        <textarea
          rows="3"
          name="additionalInformation"
          class="form-control no-resize"
          formControlName="additionalInformation"
        ></textarea>
      </div>
    </div>
  </form>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="send()" [disabled]="isHttpRequestRunning">
    @if (isHttpRequestRunning) {
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    }
    {{ 'SEND' | translate }}
  </button>
</app-modal-footer>
